export default __webpack_public_path__ + "static/Careers_US_Internship_18-f335d3b865f6a875cde765a991fa4764.jpg";